<script setup lang="ts">
import type { InputHTMLAttributes } from "vue";

// Updated 24-2
withDefaults(
	defineProps<{
		label?: string;
		bind?: InputHTMLAttributes;
	}>(),
	{
		label: "Label",
		bind: () => ({}),
	},
);

const modelValue = defineModel<string | null | undefined>();
</script>

<template>
	<div class="modern-input">
		<slot>
			<div class="group">
				<slot name="group">
					<slot name="label">
						<label v-if="label">{{ label }}</label>
					</slot>
					<slot name="input">
						<input
							v-bind="bind"
							v-model="modelValue"
						/>
					</slot>
				</slot>
			</div>
		</slot>
	</div>
</template>

<style lang="scss" scoped>
$text-color-light: $text-color-light;

.modern-input {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 0 5px;
	gap: 10px;
	width: 100%;

	.group {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 3px;

		label {
			color: $label-accent-color;
			font-size: 0.8rem;
			min-width: 100px;
			user-select: none;
		}
	}

	input:not([type="checkbox"]),
	textarea {
		width: 100%;
		font-size: 12px;
	}
}
</style>
